module.exports = __webpack_public_path__ + "static/img/11.d25e22b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/11.png
// module id = S2Nf
// module chunks = 0